// styles
import styled from 'styled-components';

const SoFormContainer = styled.div`
  display: flex;
  width: 600px;
  max-width: 600px;
  margin-left: auto;
  margin-right: auto;
`;

export default SoFormContainer;
